<template lang="pug">
  v-layout(row wrap class="mediumSmall")
    v-flex(xs12)
      .box-global-info(v-if="masivo.producto.toLowerCase().includes('soat')")
        h2
          | Datos de mi seguro
        ul
          ol
            p
              img(:src="icons.numeroPlaca" style="width:17px;margin-right:11px;margin-left:2px;" alt="numero-placa")
              | N° de placa
            p.omnesMedium.poliza-download
              | {{ masivo.placa }}
              a(:href="'https://www.interseguro.pe/soat/electronico/' + (masivo.numeroPoliza.charAt(0) === '0' ? masivo.numeroPoliza.substr(1) : masivo.numeroPoliza)" style="width:auto;display:flex;" target="_blank" @click="sendEventTracker()")
                img(:src="icons.download" alt="download")
          ol
            p
              img(:src="icons.marcaModelo" alt="marca-modelo")
              | Marca
            p.omnesMedium {{ masivo.marca }}
          ol
            p
              img(:src="icons.marcaModelo" alt="marca-modelo")
              | Modelo
            p.omnesMedium {{ masivo.modelo }}
          ol
            p
              img(:src="icons.marcaModelo" alt="año")
              | Año
            p.omnesMedium {{ masivo.fechaFabricacion }}
          ol
            p
              img(:src="icons.uso" alt="uso")
              | Uso
            p.omnesMedium {{ masivo.uso }}
          ol
            p
              img(:src="icons.calendar" alt="calendar")
              | Vigencia
              span(v-if="getStatusVigenciaSOAT(masivo.fechaFinVigenciaMasivo) === 'POR_VENCER'").label-vigencia.por-vencer Por vencer
              span(v-else-if="getStatusVigenciaSOAT(masivo.fechaFinVigenciaMasivo) === 'VENCIDO'").label-vigencia.vencido Vencido
            p.omnesMedium {{ masivo.fechaInicioVigenciaMasivo }} - {{ masivo.fechaFinVigenciaMasivo }}
          ol
            p
              img(:src="icons.montoPago" alt="montoPago")
              | Monto de pago
            p.omnesMedium {{ (masivo.primaProgramadaMoneda || '').toUpperCase() === 'NUEVO SOL' ? 'S/ ' : '$' }} {{ (Math.round(masivo.primaProgramada * 100) / 100).toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,') }}
      .box-global-info(v-else)
        h2
          | Datos de mi seguro
        ul
          ol
            p
              img(:src="icons.numeroPlaca" style="width:17px;margin-left:2px;" alt="numero-placa")
              | N° de placa
            p.omnesMedium.poliza-download
              | {{ masivo.placa }}
              img(v-if="masivo.codigoProceso && (masivo.codigoProceso || []).length > 0" :src="icons.download" @click="getPDFElectronicPolicy($event)" alt="download")
          ol
            p
              img(:src="icons.marcaModelo" alt="marca-modelo")
              | Marca
            p.omnesMedium {{ masivo.marca }}
          ol
            p
              img(:src="icons.marcaModelo" alt="marca-modelo")
              | Modelo
            p.omnesMedium {{ masivo.modelo }}
          ol
            p
              img(:src="icons.calendar" alt="calendar")
              | Vigencia
            p.omnesMedium {{ masivo.fechaInicioVigenciaMasivo }} - {{ masivo.fechaFinVigenciaMasivo }}
          ol
            p
              img(:src="icons.sumaAsegurada" alt="shield")
              | Suma Asegurada
              //- img(:src="icons.question" width="20px" @click="showTooltipModal('sumaAsegurada')" alt="question" class="question-mark-icon")
            p.omnesMedium {{ currency }}  {{ (Math.round(masivo.montoAsegurado * 100) / 100).toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,') }}
          ol
            p
              img(:src="icons.frecuenciaPago" alt="moneda")
              | Monto de pago
            p.omnesMedium {{ currency }} {{ (Math.round(masivo.netoPago * 100) / 100).toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,') }}
          ol
            p
              img(:src="icons.calendar" alt="calendar")
              | Frecuencia de pago
            p.omnesMedium {{ masivo.frecuenciaPago }}
    v-flex(xs12)
      //- SEGUN DISEÑO - BLOQUE DE COBERTURAS PARA PRODUCTOS MASIVOS QUE NO SEAN SOAT SE MUESTRAN AQUI
      .box-beneficiarios(v-if="!masivo.producto.toLowerCase().includes('soat')")
        h2
          | Mis coberturas
          img(:src="icons.question" width="20px" @click="showTooltipModal('coberturas')" alt="question" class="question-mark-icon")
        v-layout(row wrap v-for="(cobertura, index) in masivo.coberturas" :key="cobertura.nombre")
          v-flex(xs8 class="name-beneficiario")
            p {{ cobertura.nombre }}
          v-flex(xs1)
          v-flex(xs3 class="percent-beneficiario")
            p.omnesMedium 100 %
      //- COBERTURAS PARA SOAT
      .box-beneficiarios(v-else)
        h2
          | Mis coberturas
          img(:src="icons.question" width="20px" @click="showTooltipModal('coberturas')" alt="question" class="question-mark-icon")
        v-layout(row wrap v-for="(cobertura, index) in masivo.coberturasSoat" :key="cobertura.nombre")
          v-flex(xs8 class="name-beneficiario")
            p {{ cobertura.nombre }}
          v-flex(xs1)
          v-flex(xs3 class="percent-beneficiario")
            p.omnesMedium 100 %
    v-flex(xs12)
      .box-agente
        h2 Contáctanos
        v-layout(row wrap)
          v-flex(md12 lg12)
            //- p(@click="sendMailTo('servicios@interseguro.com.pe')" style="cursor:pointer")
            p
              img(:src="icons.mensajeAgente" alt="mensajeAgente")
              span(style="font-size: 13px;") Ingresa a nuestra &nbsp;
                a(:href="links.Home" target="_blank" style="text-decoration:none;")
                  b web
                | &nbsp; y conoce nuestros canales digitales
    v-flex(xs12)
      .box-comprobante-electronico
        h2
          | Comprobante Electrónico
          img(:src="icons.question" width="20px" @click="showTooltipModal('comprobanteElectronico')" alt="question" class="question-mark-icon")
        v-layout(row wrap)
          v-flex(xs4 style="flex-basis: 42.666667%; flex-grow: 0; max-width: 42.666667%;")
            label Documento
            v-select.date-selector(v-model="selectedTypeDoc" hide-details outline :items="items" placeholder='Tipo de comprobante' append-icon="expand_more")
          v-flex(xs1 style="flex-basis: 3.333333%; flex-grow: 0; max-width: 3.333333%;")
          v-flex(xs3)
            label Desde
            v-dialog(ref='dialogStart' v-model='ce.modalStart', :return-value.sync="ce.startDate" persistent='' lazy='' full-width='' width='290px')
              v-text-field(slot='activator' hide-details v-model="ce.textFieldStartDate" outline readonly='')
              v-date-picker(v-model="ce.startDate" locale="es-005" :min="ce.minDate" :max="ce.endDate" type='month' scrollable='')
                v-spacer
                v-btn(flat='' color='primary' @click="ce.modalStart = false") Cancel
                v-btn(flat='' color='primary' @click="$refs.dialogStart.save(ce.startDate)") OK
          v-flex(xs1 style="flex-basis: 3.333333%; flex-grow: 0; max-width: 3.333333%;")
          v-flex(xs3)
            label Hasta
            v-dialog(ref='dialogEnd' v-model='ce.modalEnd' :return-value.sync="ce.endDate" persistent='' lazy='' full-width='' width='290px')
              v-text-field(slot='activator' hide-details v-model="ce.textFieldEndDate" outline readonly='')
              v-date-picker(v-model="ce.endDate" locale="es-005" :min="ce.minDate" :max="ce.maxDate" type='month' scrollable='')
                v-spacer
                v-btn(flat='' color='primary' @click="ce.modalEnd = false") Cancel
                v-btn(flat='' color='primary' @click="$refs.dialogEnd.save(ce.endDate)") OK
          v-flex(xs9)
          v-flex(xs3)
            v-btn.download-btn-files(style="margin-top: 2em;" type="button" :disabled="ce.textFieldStartDate === null || ce.textFieldEndDate === null || (selectedTypeDoc === null || selectedTypeDoc === '')" @click="showComprobantesElectronicos()") APLICAR
    //- LOADER PROCESS
    v-dialog(v-model="loader" persistent width="300")
      v-card(color="primary" dark="")
        v-card-text
          | Descargando...
          v-progress-linear.mb-0(indeterminate="" color="white")
    //- MODAL INFO BULLETS
    v-dialog(v-model="bulletsModal" persistent width="100%")
      v-card
        v-card-text
          p.omnesRegular(style="text-align: center; font-size: 16px; padding: 30px 30px 24px 30px;") {{ textModal }}
          v-layout
            v-flex(xs4)
            v-flex(xs4)
              v-btn.download-btn-files.omnesSemibold(@click="bulletsModal = false" style="font-size: 17px;") ACEPTAR
            v-flex(xs4)
    //- MESSAGE COMPROBANTES ELECTRONICOS WHEN SELECT DATE
    v-dialog(v-model="messageLoader" persistent width="500")
      v-card
        v-card-text
          v-layout(wrap row)
            v-flex(md4 lg4)
            v-flex(md4 lg4 style='text-align: center;margin-top: 1em;margin-bottom: 1em')
              img(:src="icons.alerta" alt="alerta")
            v-flex(md4 lg4)
          v-layout(wrap row)
            v-flex(md12)
              p.omnesRegular.message-date-alert-ce-mobile
                | Solo podrás descargar los comprobantes desde
                br
                strong 01/2019&nbsp;
                | , si necesitas los comprobantes emitidos&nbsp;
                br
                | antes de esa fechas comunícate al&nbsp;
                br
                strong (01) 500 0000.
          v-layout(wrap row)
            v-flex(md4 lg4)
            v-flex(md4 lg4)
              v-btn.download-btn-files.btn-date-alert-ce-mobile.omnesMedium(@click="messageLoader = false") Entendido
            v-flex(md4 lg4)
    //- DIALOG COMPROBANTES ELECTRONICOS
    v-dialog(v-model="loaderCE" persistent width="500")
      v-card.card-comprobantes
        v-card-text
          img#close-btn-ce(:src="icons.close" alt="downloadCe" @click="loaderCE = false")
          h2.omnesMedium Descarga los documentos según las fechas elegidas
          v-layout.wrap__comprobantes-mobile(wrap row v-if="listComprobantesElectronicos.length > 0")
            v-flex(xs4 sm4 v-if="listComprobantesElectronicos.length === 1")
            v-flex.comprobantes(xs4 sm4 v-for="(comprobante, index) in listComprobantesElectronicos" :key="comprobante.numero")
              v-layout(row wrap)
                v-flex(xs9 sm9)
                  p {{ comprobante.fechaEmision }}
                v-flex(xs3 sm3 @click="downloadComprobanteElectronico(comprobante.tipoDocumento, comprobante.serie, comprobante.correlativo, comprobante.historico)" style="cursor:pointer;")
                  img(:src="icons.downloadCe" alt="downloadCe")
            v-flex(xs4 sm4 v-if="listComprobantesElectronicos.length === 1")
    //- MODAL DE ERROR - GENERICO PARA MENSAJES
    v-dialog(class="comprobantes-error", v-model="errorModalComprobantes", width="500")
      v-card.sign-in-modal
        figure.text-xs-center
          img(:src="icons.oops" alt="iconError")
        h2.text-blue.text-xs-center Estimado cliente
        p.mt-3.text-xs-center
          span.d-block.g-text-gray-700(style="font-size:16px") En estos momentos no hay comprobantes electrónicos disponibles. Estamos tratando de solucionarlo lo más pronto posible.
        button.transition-all-3.hover-scale(@click="errorModalComprobantes = false") Entendido
</template>

<script>
import electronicVouchers from './../../interfaces/electronicVouchers'
import moment from 'moment'
import { mapActions, mapGetters } from 'vuex'
import Links from '../../interfaces/links'
import Functionalities from '../../interfaces/functionalities'

export default {
  data () {
    return {
      links: Links,
      // TEMPORAL: Modal para mostrar inestabilidad en el API de Comprobantes
      errorModalComprobantes: false,
      loader: false,
      loaderCE: false,
      textModal: '',
      bulletsModal: false,
      currency: '',
      selectedTypeDoc: null,
      isLoadingComprobantes: false,
      hasElectronicPolicy: false,
      messageLoader: false,
      items: [],
      listComrpobantesElectronicosActuales: [],
      listComprobantesElectronicos: [],
      tooltips: {
        showSumaAsegurada: false,
        showBeneficiarios: false,
        showNumeroPoliza: false,
        showEstadoCuenta: false,
        showComprobanteElectronico: false
      },
      icons: {
        visa: require('./../../assets/cambio-cobro/icon-visa.svg'),
        calendar: require('./../../assets/iconsv5/icon-calendar.svg'),
        check: require('./../../assets/iconsv5/icon-check.svg'),
        moneda: require('./../../assets/iconsv5/icon-moneda.svg'),
        question: require('./../../assets/iconsv5/icon-question.svg'),
        shield: require('./../../assets/iconsv5/icon-shield.svg'),
        mensajeAgente: require('./../../assets/vida-icons/icon-correo.svg'),
        download: require('./../../assets/iconsv5/icon-download.svg'),
        marcaModelo: require('./../../assets/iconsv5/icon-marca-modelo.svg'),
        frecuenciaPago: require('./../../assets/iconsv5/icon-frecuencia-pago.svg'),
        montoPago: require('./../../assets/iconsv5/icon-monto-pago.svg'),
        sumaAsegurada: require('./../../assets/iconsv5/icon-suma-asegurada.svg'),
        pagadoHasta: require('./../../assets/iconsv5/icon-pagado-hasta.svg'),
        numeroPlaca: require('./../../assets/iconsv5/icon-numero-placa.svg'),
        uso: require('./../../assets/iconsv5/icon-uso.svg'),
        anho: require('./../../assets/iconsv5/icon-anho.svg'),
        close: require('./../../assets/iconsv5/icon-close-ce.svg'),
        downloadCe: require('./../../assets/iconsv5/icon-download-ce.svg'),
        alerta: require('./../../assets/iconsv5/icon-alerta.svg')
      },
      ce: {
        maxDate: null,
        minDate: null,
        modalStart: false,
        modalEnd: false,
        startDate: null,
        endDate: null,
        textFieldStartDate: null,
        textFieldEndDate: null
      },
      amplitude: {
        events: {
          downloadDocuments: 'Descarga de Documentos'
        }
      },
      color: '#1745A8',
      size: '10px'
    }
  },
  props: ['masivo'],
  watch: {
    'ce.startDate': function (val) {
      let minDateAvailable = moment('2018-12-31')
      let startDateSelected = moment(val + '-01')
      if (startDateSelected.isAfter(minDateAvailable)) {
        this.ce.textFieldStartDate = moment(this.ce.startDate).locale('es').format('MMM-YYYY').split('.').join('')
      } else {
        this.ce.modalStart = false
        this.messageLoader = true
      }
    },
    'ce.endDate': function (val) {
      let minDateAvailable = moment('2018-12-31')
      let endDateSelected = moment(val + '-01')
      if (endDateSelected.isAfter(minDateAvailable)) {
        this.ce.textFieldEndDate = moment(this.ce.endDate).locale('es').format('MMM-YYYY').split('.').join('')
      } else {
        this.ce.modalEnd = false
        this.messageLoader = true
      }
    }
  },
  methods: {
    ...mapActions('user', ['checkJWT', 'getPDFPolizaElectronica', 'getElectronicDocuments', 'downloadComprobante', 'downloadComprobanteLegacy', 'getComprobantes']),
    ...mapActions('event', ['eventLog']),
    async getPDFElectronicPolicy (evt) {
      const self = this
      evt.preventDefault()
      if (!Functionalities.isAvailable(Functionalities.masivos.DESCARGA_POLIZA, self.functionsRules, self, self.guaranteed.producto)) {
        return
      }
      this.loader = true
      // TRACK EVENT - GA
      this.$gtm.trackEvent({
        event: 'DPE',
        category: 'Zona Privada',
        action: 'PolizaElectronica',
        label: 'Descarga de Póliza Electrónica'
      })
      // TRACK EVENT - AMPLITUDE
      var productoConsultado = ''
      if (this.masivo.oriProducto === null) {
        if (this.masivo.modalidad === null) {
          productoConsultado = this.masivo.producto
        } else {
          productoConsultado = this.masivo.modalidad
        }
      } else {
        productoConsultado = this.masivo.oriProducto
      }
      this.$amplitude.getInstance()
        .logEvent(
          this.amplitude.events.downloadDocuments,
          {
            'Tipo Documento': 'Poliza ' + productoConsultado
            // 'Producto Consultado': productoConsultado
          }
        )
      await this.getPdfPoliza({numPoliza: this.masivo.numeroPoliza, makeDownload: true}, this.masivo.codigoProceso)
    },
    async getPdfPoliza (data, codigosProceso) {
      let downloaded = false
      for (let x = 0; x < codigosProceso.length && !downloaded; x++) {
        try {
          const res = await this.getPDFPolizaElectronica({...data, codProceso: codigosProceso[x]})
          if (res.status === 204) {
            this.loader = false
            if (x === codigosProceso.length - 1) {
              this.$swal({
                title: 'Comunicado',
                text: 'Lamentamos las molestias, esta póliza aún no está disponible en formato electrónico. Estamos trabajando para ofrecerla lo antes posible.',
                confirmButtonText: 'Entendido'
              })
            }
          } else {
            this.loader = false
            downloaded = true
          }
        } catch (error) {
          if (x === codigosProceso.length - 1) {
            this.loader = false
          }
        }
        /* .then(res => {
            // HTTP RESPONSE: NO CONTENT
          })
          .catch(() => {
            if (x === codigosProceso.length - 1) {
              this.loader = false
            }
          })
        */
      }
    },
    showComprobantesElectronicos () {
      const self = this
      const nombreProducto = this.masivo.nombreProducto || this.masivo.producto
      if (!Functionalities.isAvailable(Functionalities.masivos.COMPROBANTES, self.functionsRules, self, nombreProducto)) {
        return
      }
      if (this.listComrpobantesElectronicosActuales.length < 1) {
        this.errorModalComprobantes = true
      }
      // EVENT TRACK - Universal Analytics
      this.$gtm.trackEvent({
        event: 'virtualEvent',
        category: 'Zona Segura',
        action: 'Mi seguros - Comprobante electrónico',
        label: 'Seleccionar botón - Aplicar'
      })
      // EVENT TRACK - GA4
      this.$gtm.trackEvent({
        event: 'select_button',
        'Nombre Sección': 'Zona Segura',
        TipoElemento: 'Botón',
        TipoAccion: 'Mi seguros - Comprobante electrónico',
        CTA: 'Seleccionar botón - Aplicar'
      })
      if (self.ce.startDate !== null && self.ce.endDate !== null && self.selectedTypeDoc !== null) {
        this.loader = true
        // LIMPIANDO LOS COMPROBANTES
        this.listComprobantesElectronicos = []
        let startDate = moment(self.ce.startDate + '-01')
        let endDate = moment(self.ce.endDate + '-01').endOf('month')
        // COMPROBANTES ELECTRONICOS VERIFICAR QUE TIPOS TIENE (HISTORICOS O RECIENTES)
        if (self.selectedTypeDoc.includes('PP') || self.selectedTypeDoc.includes('PESC')) {
          let documents = self.listComrpobantesElectronicosHistoricos
          let selectedTypeDoc = self.selectedTypeDoc.split('.')[0]
          for (let index = 0; index < documents.length; index++) {
            let arrFechaEmisionPaper = documents[index].fechaEmision.split(' ')[0].split('/')
            let fechaEmisionPaper = arrFechaEmisionPaper[2] + '-' + arrFechaEmisionPaper[1] + '-' + arrFechaEmisionPaper[0]
            let fechaEmision = moment(fechaEmisionPaper)
            if (fechaEmision.isBetween(startDate, endDate) && (selectedTypeDoc === documents[index].tipoComprobante)) {
              let fechaEmisionFormat = moment(fechaEmisionPaper, 'YYYY-MM-DD').locale('es').format('MMM-YYYY').replace('.', '')
              fechaEmisionFormat = fechaEmisionFormat.charAt(0).toUpperCase() + fechaEmisionFormat.slice(1)
              let serie = ''
              switch (documents[index].tipoComprobante) {
              case 'FAC':
                serie = '01'
                break
              case 'B/V':
                serie = '03'
                break
              default:
                serie = '07'
                break
              }
              let hash = {
                fechaEmision: fechaEmisionFormat,
                tipoDocumento: documents[index].tipoComprobante,
                serie: serie,
                correlativo: documents[index].secuencial,
                historico: true
              }
              this.listComprobantesElectronicos.push(hash)
            }
          }
        }
        // CONDICIONAL PARA CUBRIR TODOS LOS COMPROBANTES
        if (self.selectedTypeDoc.includes('ESC') || self.selectedTypeDoc.includes('PESC')) {
          let selectedTypeDoc = ''
          if (self.selectedTypeDoc.includes('PESC')) {
            selectedTypeDoc = self.selectedTypeDoc.split('.')[1]
          } else {
            selectedTypeDoc = self.selectedTypeDoc.split('.')[0]
          }
          if (this.listComrpobantesElectronicosActuales.length > 0) {
            let documents = this.listComrpobantesElectronicosActuales
            // POBLANDO LOS COMPROBANTES
            for (let index = 0; index < documents.length; index++) {
              let fechaEmision = moment(documents[index].fechaEmision)
              if (fechaEmision.isBetween(startDate, endDate) && (selectedTypeDoc === documents[index].tipoComprobante)) {
                let fechaEmisionFormat = moment(documents[index].fechaEmision, 'YYYY-MM-DD').locale('es').format('MMM-YYYY').replace('.', '')
                fechaEmisionFormat = fechaEmisionFormat.charAt(0).toUpperCase() + fechaEmisionFormat.slice(1)
                let hash = {
                  fechaEmision: fechaEmisionFormat,
                  tipoDocumento: documents[index].tipoComprobante,
                  serie: documents[index].serie,
                  correlativo: documents[index].numero,
                  historico: false
                }
                this.listComprobantesElectronicos.push(hash)
              }
            }
            this.loader = false
            this.loaderCE = true
          } else {
            this.loader = false
          }
        }
        this.loader = false
        this.loaderCE = true
      } else {
        self.$swal({
          title: 'Estimado cliente',
          text: 'Debe completar la información para buscar sus comprobantes electrónicos.',
          confirmButtonText: 'Entendido'
        })
      }
    },
    downloadComprobanteElectronico (tipoComprobante, serie, numero, esHistorico) {
      const nombreProducto = this.masivo.nombreProducto || this.masivo.producto
      if (!Functionalities.isAvailable(Functionalities.masivos.COMPROBANTES, this.functionsRules, this, nombreProducto)) {
        return
      }
      this.loader = true
      let hash = {
        tipoDocumento: tipoComprobante,
        serie: serie,
        correlativo: numero,
        producto: this.masivo.oriProducto || this.masivo.producto,
        grupoProducto: this.masivo.ramo.toUpperCase(),
        numeroPoliza: this.masivo.numeroPoliza
      }
      // TRACK EVENT - GA
      this.$gtm.trackEvent({
        event: 'Descargas Comprobantes Elec.',
        category: 'Zona Privada',
        action: 'ComprobantesElectronicos',
        label: 'Descarga de Comprobantes Electrónicos'
      })
      // TRACK EVENT - AMPLITUDE
      var productoConsultado = ''
      if (this.masivo.oriProducto === null) {
        if (this.masivo.modalidad === null) {
          productoConsultado = this.masivo.producto
        } else {
          productoConsultado = this.masivo.modalidad
        }
      } else {
        productoConsultado = this.masivo.oriProducto
      }
      this.$amplitude.getInstance()
        .logEvent(
          this.amplitude.events.downloadDocuments,
          {
            'Tipo Documento': 'Comprobantes Electrónicos',
            'Producto Consultado': productoConsultado,
            'Meses consultados': [this.ce.startDate.split('-')[1], this.ce.endDate.split('-')[1]]
          }
        )
      const callbackEventLog = (omitEvent) => {
        if (!omitEvent) {
          this.eventLog({
            categoria: 'Documentos',
            nombre: 'Descarga Comprobantes/Boletas',
            datos: hash
          })
        }
        setTimeout(() => {
          self.$root.$emit('showNps', {
            nombre: 'NPS - Inicio de Encuesta',
            funcionalidad: 'Descarga de Comprobante',
            metadata: self.metadata
          })
        }, 3000)
      }
      if (esHistorico) {
        hash.Tipo = 'histórico'
        let xml = {
          tipoDoc: serie,
          folio: numero
        }
        this.downloadComprobanteLegacy(xml)
          .then(res => {
            this.loader = false
            hash.Estado = 'Exitoso'
            hash.respuesta = res.data
            hash.statusCode = res.status
            callbackEventLog()
          })
          .catch((err) => {
            hash.error = err.response.data
            hash.statusCode = err.response.status
            this.loader = false
            callbackEventLog()
          })
      } else {
        this.downloadComprobante(hash)
          .then((res) => {
            this.loader = false
            callbackEventLog(true)
          })
          .catch((err) => {
            this.loader = false
            if (err.data.codigoRespuesta === '99') {
              this.$swal({
                title: 'Estimado cliente',
                text: 'El Comprobante de Pago Electrónico ' + numero + ' , especificado no está registrado o no se encuentra en estado ACEPTADO.',
                confirmButtonText: 'Entendido'
              })
            } else {
              callbackEventLog(true)
            }
          })
      }
    },
    showTooltipModal (obj) {
      switch (obj) {
      case 'poliza':
        this.bulletsModal = true
        this.textModal = 'Obtén las condiciones de tu póliza contratada cuando lo necesites.'
        break

      case 'sumaAsegurada':
        this.bulletsModal = true
        this.textModal = 'El monto indicado es la suma asegurada por fallecimiento.'
        break

      case 'coberturas':
        this.bulletsModal = true
        this.textModal = 'Detallamos las coberturas que les corresponde de tu póliza vehicular.'
        break

      case 'comprobanteElectronico':
        this.bulletsModal = true
        this.textModal = 'Podrás descargar tus comprobantes como boleta, factura, nota de crédito del periodo que elijas.'
        break

      case 'beneficiarios':
        this.bulletsModal = true
        this.textModal = 'Detallamos el nombre de tus beneficiarios así como el % que les corresponde de tu suma asegurada.'
        break

      case 'estadoCuenta':
        this.bulletsModal = true
        this.textModal = 'Encuentra el estado de póliza, monto de cobertura, pagos, fecha de pago.'
        break
      }
    },
    closeModalMasivo () {
      // HIDE SUB-NAV
      this.$root.$emit('hideMasivo', {})
    },
    sendEventTracker () {
      const self = this
      // TRACK EVENT - AMPLITUDE
      var productoConsultado = ''
      if (this.masivo.oriProducto === null) {
        if (this.masivo.modalidad === null) {
          productoConsultado = this.masivo.producto
        } else {
          productoConsultado = this.masivo.modalidad
        }
      } else {
        productoConsultado = this.masivo.oriProducto
      }
      this.$amplitude.getInstance()
        .logEvent(
          this.amplitude.events.downloadDocuments,
          {
            'Tipo Documento': 'Poliza SOAT',
            'Producto Consultado': productoConsultado
          }
        )
      // TRACK EVENT - GA
      this.$gtm.trackEvent({
        event: 'Poliza SOAT Electronica',
        category: 'Zona Privada',
        action: 'PolizaSoatElectronica',
        label: 'Descarga de Póliza SOAT Electronica'
      })
      this.eventLog({
        categoria: 'Documentos',
        nombre: 'Descarga póliza electrónica',
        datos: {
          producto: self.masivo.oriProducto,
          grupoProducto: self.masivo.ramo.toUpperCase(),
          numeroPoliza: self.masivo.numeroPoliza,
          Estado: 'Exitoso'
        }
      })
    },
    getStatusVigenciaSOAT (fechaVencimiento) {
      let dia, mes, anio
      if (fechaVencimiento.split('-')[2] !== undefined) {
        let split = fechaVencimiento.split('-')
        dia = parseInt(split[2])
        mes = parseInt(split[1]) - 1
        anio = parseInt(split[0])
      } else {
        let split = fechaVencimiento.split('/')
        dia = parseInt(split[0])
        mes = parseInt(split[1]) - 1
        anio = parseInt(split[2])
      }
      let currentDate = new Date()
      let finVigenciaDate = new Date(anio, mes, dia)
      let diff = (finVigenciaDate - currentDate)
      if (diff < 0) {
        return 'VENCIDO'
      } else {
        const expirationDays = diff / (1000 * 3600 * 24)
        if (expirationDays <= 45) {
          return 'POR_VENCER'
        }
      }
      return ''
    },
    sendMailTo (mail) {
      let link = document.createElement('a')
      link.href = 'mailto:' + mail
      link.click()
    }
  },
  mounted () {
    // WARN: MONEDA de la póliza
    this.currency = this.masivo.primaProgramadaMoneda === 'US DOLAR' ? '$' : 'S/ '
    this.ce.maxDate = moment().format('YYYY-MM')
    let minArrDate = this.masivo.fechaInicioVigenciaMasivo.split('/')
    this.ce.minDate = minArrDate[2] + '-' + minArrDate[1]
    // TMP: Fechas para comprobante electronico
    this.ce.startDate = moment(new Date(), 'DD-MM-YYYY').subtract(1, 'months').format('YYYY-MM')
    this.ce.endDate = moment(new Date(), 'DD-MM-YYYY').format('YYYY-MM')
    // COMPROBANTES ELECTRONICOS VERIFICAR QUE TIPOS TIENE
    this.items = []
    let item = { numeroPoliza: Number(this.masivo.numeroPoliza).toString() }
    let self = this
    /*
    self.getElectronicDocuments(item)
      .then((res) => {
        if (res.data.documentosElectronicos.length > 0) {
          self.listComrpobantesElectronicosHistoricos = res.data.documentosElectronicos
          let arrVouchers = self.listComrpobantesElectronicosHistoricos.map(f => { return f.tipoComprobante })
          let arrTypeDocs = arrVouchers.filter(function (item, index) { return arrVouchers.indexOf(item) >= index })
          for (let index = 0; index < arrTypeDocs.length; index++) {
            switch (arrTypeDocs[index]) {
            case 'FAC':
              self.items.push({text: 'Factura', value: 'FAC.PP'})
              break
            case 'N/C':
              self.items.push({text: 'Nota crédito', value: 'N/C.PP'})
              break
            case 'B/V':
              self.items.push({text: 'Boleta de venta', value: 'B/V.PP'})
              break
            }
          }
        }
      })
    */
    const datosEventLog = {
      producto: self.masivo.oriProducto || self.masivo.producto,
      grupoProducto: self.masivo.ramo.toUpperCase(),
      numeroPoliza: self.masivo.numeroPoliza
    }
    self.getComprobantes(item)
      .then((res) => {
        if ((res.data.codigoRespuesta === '01') && (res.data.documentos.length > 0)) {
          datosEventLog.documentos = res.data.documentos
          datosEventLog.Estado = 'Exitoso'
          self.listComrpobantesElectronicosActuales = res.data.documentos
          let documents = self.listComrpobantesElectronicosActuales
          let arrDocuments = []
          // SE OBTIENE LOS CODIGOS DE SUNAT DE CADA COMPROBANTE
          for (let index = 0; index < documents.length; index++) {
            arrDocuments.push(documents[index].tipoComprobante)
          }
          let arrDocsUniq = arrDocuments.filter(function (item, pos) {
            return arrDocuments.indexOf(item) === pos
          })
          // - this.items.push({ text: 'Tipo de comprobante', value: null })
          arrDocsUniq.forEach(el => {
            for (let j = 0; j < electronicVouchers.length; j++) {
              let noEncontroMatch = true
              // SE HACE MATCH
              if (electronicVouchers[j].codigoSunat === el) {
                // DETECTAR SI YA ESTA REPETIDO DEL LEGACY
                for (let x = 0; x < self.items.length; x++) {
                  if (self.items[x].text === electronicVouchers[j].descripcion) {
                    let newValue = self.items[x].value.split('.')
                    self.items[x].value = newValue[0] + '.' + electronicVouchers[j].codigoSunat + '.PESC'
                    noEncontroMatch = false
                    break
                  }
                }
                if (noEncontroMatch) {
                  self.items.push({ text: electronicVouchers[j].descripcion, value: electronicVouchers[j].codigoSunat + '.ESC' })
                  break
                }
              }
            }
          })
          if (self.items.length === 1) {
            self.selectedTypeDoc = self.items[0].value
          }
        } else if ((res.data.codigoRespuesta === '01') && (res.data.documentos.length === 0)) {
          datosEventLog.error = res.data
          datosEventLog.statusCode = res.status
          datosEventLog.Estado = 'Vacío'
          this.$swal({
            title: 'Hola, ',
            text: 'En estos momentos, estamos trabajando en poner a disposición tu comprobante. Pero no te preocupes, en un plazo máximo de 5 días hábiles ya lo tendrás listo para la descarga.',
            confirmButtonText: 'Entendido'
          })
        } else {
          datosEventLog.Estado = 'Error'
          datosEventLog.error = res.data
          datosEventLog.statusCode = res.status
        }
        this.eventLog({
          categoria: 'Documentos',
          nombre: 'Consulta Comprobantes/Boletas',
          datos: datosEventLog
        })
      })
      .catch((err) => {
        datosEventLog.Estado = 'Error'
        datosEventLog.error = err.response
        this.eventLog({
          categoria: 'Documentos',
          nombre: 'Consulta Comprobantes/Boletas',
          datos: datosEventLog
        })
      })
  },
  computed: {
    ...mapGetters('user', ['userInfo', 'functionsRules'])
  }
}
</script>

<style>
/** GLOBAL INFO */
.mediumSmall .box-global-info { border-bottom: #D8D8D8 12px solid; }
.mediumSmall .box-global-info ul { padding: 3px 0; }
.mediumSmall .box-global-info ul ol {
  overflow: hidden;
  padding-left: 0;
  border-bottom: 1px solid #D8D8D8;
  padding: 12px 22px;
}
.mediumSmall .box-global-info ul ol:last-child { border-bottom: 0; }
.mediumSmall .box-global-info ul ol p {
  margin-bottom: 0;
  display: flex;
  align-items: center;
}
.mediumSmall .box-global-info ul ol p:first-child { float: left; }
.mediumSmall .box-global-info ul ol p:first-child + p { float: right; }
.mediumSmall .box-global-info ul ol p.poliza-download img {
  margin-right: 0;
  margin-left: 7px;
}
.mediumSmall .box-global-info ul ol p img {
  margin-right: 9px;
  width: 20px;
}
/** BENEFICIARIOS */
.mediumSmall .box-beneficiarios {
  border-bottom: #D8D8D8 12px solid;
  padding: 16px 0px;
  margin: 0;
}
.mediumSmall .box-beneficiarios .layout {
  margin-bottom: 0 !important;
  border-bottom: 1px solid #D8D8D8;
}
.mediumSmall .box-beneficiarios .layout { padding: 12px 22px; }
.mediumSmall .box-beneficiarios h2 {
  padding: 0 22px;
  margin-bottom: 0.4em !important;
}
.mediumSmall .box-beneficiarios .layout .percent-beneficiario p,
.mediumSmall .box-beneficiarios .layout .name-beneficiario p {
  margin-bottom: 0;
}
.mediumSmall .box-beneficiarios .layout .name-beneficiario p { text-transform: lowercase !important; }
.mediumSmall .box-beneficiarios .layout .name-beneficiario p::first-letter { text-transform: uppercase !important; }
.mediumSmall .box-beneficiarios .layout .percent-beneficiario p {
  text-align: right;
}
.mediumSmall .box-beneficiarios .layout:last-child { margin-bottom: 0.4em !important; }
/** AGENTE */
.mediumSmall .box-agente {
  border-bottom: #D8D8D8 12px solid;
  padding: 16px 22px;
}
.mediumSmall .box-agente .layout .flex {
  /* border: #D8D8D8 1px solid; */
  padding: 3px 2px !important;
}
.mediumSmall .box-agente .layout .flex p {
  margin-bottom: 0;
  display: block;
  font-weight: normal;
  font-family: 'Omnes Medium';
}
.mediumSmall .box-agente .layout .flex p img {
  width: 19px;
  margin-right: 12px;
  position: relative;
  top: 3px;
}
/** NUMERO DE POLIZA */
.mediumSmall .box-numero-poliza .layout .flex p {
  border: #D8D8D8 1px solid;
  padding: 0 24px;
  font-size: 16px;
  font-family: 'Omnes Medium';
  margin-bottom: 0;
  height: 41px;
  line-height: 44px;
}
/** MEDIO DE PAGO */
.mediumSmall .box-medio-pago h2 {
  color: #0855C4;
  font-weight: normal;
  font-size: 18px;
  margin-bottom: 0.5em;
}
.mediumSmall .box-medio-pago .layout .flex p {
  border: #D8D8D8 1px solid;
  padding: 0 24px;
  font-family: 'Omnes Medium';
  height: 42px;
  line-height: 42px;
}
/** ESTADO DE CUENTA */
/** COMPROBANTE ELECTRONICO */
.mediumSmall .box-comprobante-electronico {
  padding: 16px 22px;
}
.mediumSmall .box-comprobante-electronico .layout .flex .v-input.date-selector .v-input__control .v-input__slot {
  min-height: 46px;
  border: 1px solid #D8D8D8;
}
.mediumSmall .box-comprobante-electronico .layout .flex .v-input.date-selector .v-input__control .v-input__slot .v-select__slot label { top: 14px; }
.mediumSmall .box-comprobante-electronico .layout .flex .v-input.date-selector .v-input__control .v-input__slot .v-select__slot .v-select__selections { padding-top: 3px; }
.mediumSmall .box-comprobante-electronico .layout .flex .v-input.date-selector .v-input__control .v-input__slot .v-select__slot .v-select__selections input::placeholder { color: rgba(0,0,0,0.87); }
.mediumSmall .box-comprobante-electronico .layout .flex .v-input.date-selector .v-input__control .v-input__slot .v-select__slot .v-select__selections .v-select__selection { margin: 0; }
.mediumSmall .box-comprobante-electronico .layout .flex .v-input.date-selector .v-input__control .v-input__slot .v-select__slot .v-input__append-inner { margin-top: 12px; }
.mediumSmall .box-comprobante-electronico .layout .flex .v-input.date-selector .v-input__control .v-input__slot .v-select__slot .v-input__append-inner .v-input__icon i {
  color: #0855C4;
  font-size: 30px;
}
/** GLOBAL STYLES */
.mediumSmall .flex .box-global-info h2 {
  padding: 0 22px;
  margin: 1em 0 0.4em 0;
}
.mediumSmall .box-global-info h2,
.mediumSmall .box-beneficiarios h2,
.mediumSmall .box-comprobante-electronico h2,
.mediumSmall .box-numero-poliza h2,
.mediumSmall .box-agente h2,
.mediumSmall .box-beneficiarios h2 {
  display: flex;
  color: #0855C4;
  font-size: 18px;
  font-weight: normal;
  margin-bottom: 0.7em;
}
.mediumSmall .box-beneficiarios h2 img.question-mark-icon,
.mediumSmall .box-comprobante-electronico h2 img.question-mark-icon,
.mediumSmall .box-numero-poliza h2 img.question-mark-icon,
.mediumSmall .box-agente h2 img.question-mark-icon,
.mediumSmall .box-beneficiarios h2 img.question-mark-icon,
.mediumSmall .box-global-info ul ol p:first-child img.question-mark-icon {
  margin-left: 8px;
}
.mediumSmall .box-numero-poliza,
.mediumSmall .box-medio-pago {
  border-bottom: 12px solid #D8D8D8;
  margin-bottom: 0;
  padding: 16px 15px;
}
.mediumSmall .box-comprobante-electronico .layout {
  margin-top: 10px;
}
.mediumSmall .box-comprobante-electronico .flex p {
  margin-bottom: 6px;
  font-size: 16px;
}
.mediumSmall .box-comprobante-electronico .flex .v-dialog__container .v-dialog__activator .v-input .v-input__control .v-input__slot .v-input__prepend-inner {
  padding-right: 6px;
  margin-top: 2px;
}
.mediumSmall .box-comprobante-electronico .flex .v-dialog__container .v-dialog__activator .v-input .v-input__control .v-input__slot {
  min-height: 46px;
  border: 1px solid #D8D8D8;
}
.mediumSmall .box-comprobante-electronico .flex .v-dialog__container .v-dialog__activator .v-input .v-input__control .v-input__slot .v-text-field__slot input {
  margin-top: 7px;
}
.v-btn.download-btn-files .v-btn__content,
#btnDownloadEstado .v-btn__content {
  font-family: 'Omnes Medium';
  color: #FFF;
}
/** MODAL DE COMPROBANTES */
#close-btn-ce {
  cursor: pointer;
  float: right;
}
.card-comprobantes h2 {
  text-align: center;
  clear: both;
  width: 95%;
  margin-top: 2.5em;
  margin-bottom: 1em;
}
.card-comprobantes .flex.comprobantes .layout {
  border: 2px solid #D8D8D8;
  border-radius: 4px;
}
.card-comprobantes .flex.comprobantes .layout .flex {
  text-align: center;
}
.card-comprobantes .flex.comprobantes .layout .flex p {
  margin-bottom: 0;
  margin: 10px 0;
  border-right: 1px solid #D8D8D8;
}
.card-comprobantes .flex.comprobantes .layout .flex img {
  border-bottom: 2px solid var(--fuchsia-color);
  padding-bottom: 3px;
  padding-top: 6px;
}
.card-comprobantes .flex.comprobantes .layout .flex:first-child + .flex {
  align-self: center;
}
.card-comprobantes .wrap__comprobantes-mobile .comprobantes {
  flex-basis: 31.333333%;
  flex-grow: 0;
  max-width: 31.333333%;
  margin-right: 5px;
}
p.message-date-alert-ce-mobile {
  font-size: 14px;
  text-align: center;
}
.v-btn.download-btn-files.btn-date-alert-ce-mobile {
  width: 100%;
  padding: 16px 0 17px 0;
  height: 50px;
  margin-bottom: 1em;
}
.v-btn.download-btn-files.btn-date-alert-ce-mobile .v-btn__content {
  font-size: 17px;
}
span.label-vigencia {
  margin-left: 5px;
  font-weight: bold;
}
span.label-vigencia.por-vencer {
  color: rgb(234, 12, 144);
}
</style>



// WEBPACK FOOTER //
// src/components/masivos/FormMobileMasivo.vue